<script setup>
  import { useI18n } from 'vue-i18n';
  import { useWidgetStore } from '@/stores/WidgetStore';

  // Opens the Download Logos modal; shown in the Global Settings toolbar, or under the widget
  // cards when the toolbar is too narrow
  const widgetStore = useWidgetStore();

  const props = defineProps({
    // 'toolbar' or 'page' (under the widget cards: larger, on a surface)
    placement: {
      type: String,
      default: 'toolbar'
    }
  });

  const emit = defineEmits(['open']);

  const { t } = useI18n();

  function handleClick() {
    emit('open');
  }
</script>

<template>
  <button
    @click="handleClick"
    type="button"
    class="jwx-button jwx-button--pill jwx-widget-logos-button"
    :class="{ 'jwx-p-left-md': props.placement === 'toolbar' }"
    data-surface="0"
    :data-placement="props.placement"
  >
    <img v-if="widgetStore.logoIconUrl" :src="widgetStore.logoIconUrl" alt="" class="jwx-m-right-md">{{ t('widgets.logos.title') }}
  </button>
</template>
